import { ICadastrarCliente } from "../../../Interfaces/Geral/CadastrarCliente/CadastrarClienteInterfaces";
import {
    CadastrarClienteService,
    ListarCidadeService,
    ListarEstadosService,
    ListarProfissoesService,
    ListarSetorService,
    ListarTipoContasService,
} from "../../../Services/Geral/CadastrarCliente";
import { Controller } from "../../Controller";

export function CadastrarClienteController(requestBody: ICadastrarCliente) {
    return Controller(CadastrarClienteService(requestBody));
}

export function ListarTipoContasController() {
    return Controller(ListarTipoContasService());
}

export function ListarSetorController() {
    return Controller(ListarSetorService());
}
export function ListarEstadosController() {
    return Controller(ListarEstadosService());
}

export function ListarCidadesController(idEstado: number) {
    return Controller(ListarCidadeService(idEstado));
}

export function ListarProfissoesController() {
    return Controller(ListarProfissoesService());
}
